import Accordion from "components/blocks/Accordion";
import AccordionItem from "components/blocks/Accordion/AccordionItem";
import AttachmentCard from "components/blocks/AttachmentCard";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { OrderLocalItemResult } from "services/orders/models/OrdersTypes";
import { FileResult } from "services/shared-models/sharedTypes";

const Recommendations = ({ order }: { order: OrderLocalItemResult }) => {
    const { t } = useTranslation("Orders");
    if ((!order?.selectedProgramOrderExaminers ||
        order?.selectedProgramOrderExaminers?.length==0)
    ) return <></>; // Return empty fragment if order is null or isbn is not present
    
    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("examinerRecommendations")} elementId={"examinerRecommendations"}>

                {order?.selectedProgramOrderExaminers.map((examiner,index) => {

                    return <>
                        <div className={"d-flex align-items-center gap-4 flex-wrap"}>
                            <div className={"fw-bold fs-6"}> {t("examiner")} {index+1}:</div>
                            <div className={"d-flex flex-column flex-1 gap-2 border-1 " }>
                                {examiner.showRecommendation &&
                                    examiner.programOrderExaminer?.examinerEvaluationFormValue?.criteriaValues?.filter(w=>w.isShowable && (w.notes!='' && w.notes))?.length>0
                                    && (<div className={"fw-bold"}> {t("CriteriaRecommendation")}:</div>)}
                                {examiner.showRecommendation &&
                                    examiner.programOrderExaminer?.examinerEvaluationFormValue?.criteriaValues?.filter(w=>w.isShowable && (w.notes!='' && w.notes))?.length>0
                                    && (<div className={"d-flex flex-column gap-2 my-2 "}>

                                        {examiner.programOrderExaminer?.examinerEvaluationFormValue?.criteriaValues?.filter(w=>w.isShowable && (w.notes!='' && w.notes) ).map((criteria ,index)=>(
                                            <div className={"d-flex gap-2"}>
                                                <div className={"fw-bold"}> {index+1} - </div>
                                                <div> {criteria?.notes|| ''}</div>
                                            </div>
                                        ))}
                                    </div>)}
                                {examiner.showFiles && (<div className={"fw-bold"}> {t("Files")}:</div>)}
                                {examiner.showFiles && (
                                    <div className="d-flex gap-3 mt-2 ">
                                        {examiner?.programOrderExaminer?.examinerEvaluationFormValue?.files?.length ? (
                                            examiner?.programOrderExaminer?.examinerEvaluationFormValue?.files?.map((attachment) => (
                                                <AttachmentCard
                                                    key={attachment.id}
                                                    attachment={{
                                                        id: attachment.id,
                                                        fileName: attachment.name ?? "",
                                                        size: attachment.size ?? "",
                                                        extension: attachment.extension ?? "",
                                                    }}
                                                />
                                            ))
                                        ) : (
                                            <span>{t("Common:noData")}</span>
                                        )}
                                    </div>)}
                            </div>
                        </div>

                    </>
                }) }

                <div className="divider mt-4 "></div>
            </AccordionItem>
        </Accordion>
    ) 
};

export default Recommendations;
